import { ReportCCSPayments } from './ccs-payments'
import { ReportIssCaseClaimPaymentsReport } from './iss-case-claims'
import { ReportMissingApprovals } from './missing-approvals'
import { ReportCCSSessions } from './ccs-sessions'
import { ReportCCSNotifications } from './ccs-notifications'
import { ReportCCSEntitlementChanges } from './ccs-entitlements-changes'
import { ReportCCSEventsManagement } from './ccs-events-management'

export const reportList = [
  {
    name: 'CCS Payments',
    id: 'ccs_payments_report',
    component: ReportCCSPayments
  },
  {
    name: 'CCS Submissions',
    id: 'ccs_sessions_report',
    component: ReportCCSSessions
  },
  {
    name: 'ISS Case Claims Payments',
    id: 'iss_claims_report',
    component: ReportIssCaseClaimPaymentsReport
  },
  {
    name: 'Missing CWA Approvals',
    id: 'outstanding_cwa_report',
    component: ReportMissingApprovals
  },
  {
    name: 'CCS Notifications',
    id: 'ccs_notifications_report',
    component: ReportCCSNotifications
  },
  {
    name: 'CCS Entitlements Changes',
    id: 'ccs_entitlements_changes_report',
    component: ReportCCSEntitlementChanges
  },
  {
    name: 'CSS Events Management',
    id: 'css_events_management_report',
    component: ReportCCSEventsManagement
  }
]



// WEBPACK FOOTER //
// ./src/reports/reports/index.js